import GerenciamentoImpostosController from "@/shared/controllers/gerenciamentoImpostos/gerenciamentoImpostosController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import gClaims from "@/components/g-claims/g-claims.vue";
import AccountLoged from "@/shared/mixins/AccountLoged";

const name = 'GerenciamentoImpostos'
export default({
    name,
  
    components: { 
      gClaims,
    },
  
    props: { },

    mixins:[AccountLoged],
  
    mounted () {
      if(!this.hasClaim('Gerenciamento-Impostos')) {
        this.$router.push('/sem-acesso')
      }
    },
  
    updated () { },
  
    data () {
      return {
        ArrayRepresentantes: [],
        indexEdicao: -1,
        representanteSelecionado: null,
        RepresentantesImpostos: [],
        popupEdicao: false,
        itemSelecionado: {},
        Colunas : [
          {field: 'nomeRepresentante', header: 'Representante', ordena: false,  width: '100px',},
          {field: 'valorIRFormatado', header: 'IR (%)', ordena: false,  width: '50px',},
          {field: 'valorISSFormatado', header: 'ISS (%)', ordena: false,  width: '50px',}
        ],
  
  
      }
    },
  
    methods: {
        camponumero($event) { // funcao para campo quantidade aceite apenas numero
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
              $event.preventDefault();
            }
          },

  
      limpar(){
        this.representanteSelecionado = null;
      },
  
      buscarRepresentante(event){
        window.clearTimeout(this.timer);
        this.timer = setTimeout(() => { 
          RepresentanteController
          this.ArrayRepresentantes = RepresentanteController.getRepresentanteByPesquisa(null, event).RepresentanteArray;
        }, 1000);
      },
      buscar(){
        this.$isLoading(true)
        GerenciamentoImpostosController.GetImpostosByRepresentante(this.representanteSelecionado).requisicao
        .then(res => {
          this.RepresentantesImpostos = res.data.data
        })
        .finally(()=> {
          this.$isLoading(false)
        })
      },
      abrirPopupEdicao(informacao, index){
        this.indexEdicao = index;
        this.itemSelecionado = informacao;
        this.popupEdicao = true;
      },
  
      retornaSimENao(valor){
        return valor ? 'SIM' : 'NÃO'
      },
  
      atualizarInfos(){
        const representanteId = this.itemSelecionado.id;
        const IR = this.itemSelecionado.valorIRFormatado;
        const ISS = this.itemSelecionado.valorISSFormatado;
        GerenciamentoImpostosController.AtualizaImpostosByRepresentanteId(representanteId, IR, ISS).requisicao
        .then(res => {
          let tipoToast = "error"
          let tituloToast = "Erro ao atualizar as informações"
          let detalhesToast = "Ocorreu um erro ao atualizar as informações"
  
          if(res.data.data){
            tipoToast = "success"
            tituloToast = "Informações atualizadas com sucesso!"
            detalhesToast = "As informações da cidade foram atualizadas com sucesso"
          }
  
          this.$toast.add({ severity: tipoToast, summary: tituloToast, detail: detalhesToast, life: 3000 })
          this.popupEdicao = false;
  
  
          this.RepresentantesImpostos[this.indexEdicao].valorISSFormatado = ISS ;
          this.RepresentantesImpostos[this.indexEdicao].valorIRFormatado = IR;
  
        //   this.RepresentantesImpostos[this.indexEdicao].ehFechado = this.retornaSimENao(ehFechado) === 'SIM' ;
        //   this.RepresentantesImpostos[this.indexEdicao].ehFracionado = this.retornaSimENao(ehFracionado) === 'SIM' ;
        })
      },
  
      fecharPopup(){
        this.popupEdicao = false
      }
    },
  
    computed: { },
  
  });